"use strict";

exports.__esModule = true;
exports.LANGUAGE_KEY = void 0;
var LANGUAGE_KEY = exports.LANGUAGE_KEY = "gatsby-i18next-language";

// Taken from https://github.com/gatsbyjs/gatsby/blob/master/packages/gatsby-source-filesystem/index.d.ts
// No way to refer it without directly depending on gatsby-source-filesystem.